'use client';

import { c as _c } from "react/compiler-runtime";
import { makeStore } from '@lib/store/store';
import { useState } from 'react';
import { Provider } from 'react-redux';
export function Providers(t0) {
  const $ = _c(5);
  const {
    children,
    initialState
  } = t0;
  let t1;
  if ($[0] !== initialState) {
    t1 = () => makeStore(initialState);
    $[0] = initialState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [store] = useState(t1);
  let t2;
  if ($[2] !== children || $[3] !== store) {
    t2 = <Provider store={store}>{children}</Provider>;
    $[2] = children;
    $[3] = store;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}